export enum ResidentChangeLogType {
  Unknown = 'Unknown',

  InformationAdded = 'InformationAdded',
  InformationUpdated = 'InformationUpdated',
  InformationDeleted = 'InformationDeleted',

  DeviceLinked = 'DeviceLinked',
  DeviceUnlinked = 'DeviceUnlinked',

  ScenarioActivated = 'ScenarioActivated',
  ScenarioDeactivated = 'ScenarioDeactivated',

  ScenarioNotificationTypeChanged = 'ScenarioNotificationTypeChanged',
  ScenarioAlwaysActiveEnabled = 'ScenarioAlwaysActiveEnabled',
  ScenarioAlwaysActiveDisabled = 'ScenarioAlwaysActiveDisabled',

  ScenarioTimeFramesUpdated = 'ScenarioTimeFramesUpdated',
  ScenarioSendAlarmTimeChanged = 'ScenarioSendAlarmTimeChanged',

  AcousticThresholdChanged = 'AcousticThresholdChanged',
  AcousticDurationChanged = 'AcousticDurationChanged',
  AcousticTemporaryOverwriteEnabled = 'AcousticTemporaryOverwriteEnabled',
  AcousticTemporaryOverwriteDisabled = 'AcousticTemporaryOverwriteDisabled',
  AcousticTemporaryOverwriteConfigurationChanged = 'AcousticTemporaryOverwriteConfigurationChanged',

  VideoPrivacyModeEnabled = 'VideoPrivacyModeEnabled',
  VideoPrivacyModeDisabled = 'VideoPrivacyModeDisabled',

  ScenarioWhenActiveAlarmChanged = 'ScenarioWhenActiveAlarmChanged',
  AcousticScenarioConfigurationChanged = 'AcousticScenarioConfigurationChanged',
  WanderingDetectionScenarioConfigurationChanged = 'WanderingDetectionScenarioConfigurationChanged',
}
